import styled, { css } from 'styled-components'

import { media } from '../../../utils/mediaQuery'

export const PrintControlContainer = styled.button.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<{
  $position?: {
    top?: string
    right?: string
    bottom?: string
    left?: string
  }
  $zIndex?: number
}>`
  position: absolute;
  ${({ $position }) =>
    $position
      ? css`
          ${$position.top && `top: ${$position.top};`}
          ${$position.right && `right: ${$position.right};`}
          ${$position.bottom && `bottom: ${$position.bottom};`}
          ${$position.left && `left: ${$position.left};`}
        `
      : css`
          top: 16px;
          right: 16px;
        `}

  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: ${({ $zIndex }) => $zIndex || 10};
  box-shadow: ${({ theme }) => theme.shadows.sm};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
    box-shadow: ${({ theme }) => theme.shadows.md};
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon,
  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.colors.text.primary};
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }

  ${media.tabletDown} {
    width: 36px;
    height: 36px;

    .icon,
    svg {
      width: 18px;
      height: 18px;
    }
  }
`
